import { render, staticRenderFns } from "./IndexNav.vue?vue&type=template&id=59963bca&scoped=true"
import script from "./IndexNav.vue?vue&type=script&lang=js"
export * from "./IndexNav.vue?vue&type=script&lang=js"
import style0 from "./IndexNav.vue?vue&type=style&index=0&id=59963bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59963bca",
  null
  
)

export default component.exports